/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AutoEmailTaskCreatePriority = typeof AutoEmailTaskCreatePriority[keyof typeof AutoEmailTaskCreatePriority];


export const AutoEmailTaskCreatePriority = {
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
